import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import { type OfferBid } from '../domain/OfferBid'

type BidRepositoryDependencies = {
  httpClient: HttpClientInterface
}

type BidRequestParams = {
  offer_id: string
  price: number
  bid_probability?: boolean
  automated_bid_responses?: boolean
}

export type CreateBidParams = {
  offerUUID: string
  price: number
  bidProbability?: boolean
  config?: Partial<HttpClientConfig>
}

export class BidRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: BidRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async createBid({
    offerUUID,
    price,
    bidProbability,
    config,
  }: CreateBidParams): Promise<OfferBid> {
    const endpoint = '/api/v2/loadboard/bids'

    const data: BidRequestParams = {
      offer_id: offerUUID,
      price,
      automated_bid_responses: true,
    }
    if (bidProbability) {
      data['bid_probability'] = bidProbability
    }

    const { data: offerBid } = await this.httpClient.post(endpoint, data, config)
    return offerBid
  }
}
